import { emitTrack, WidgetSettings } from '@/tracker'
import { userSettings } from '@/globals/userSettings'

function buildSettings(): WidgetSettings {
  const s = userSettings.states
  return {
    font_size: s.fontSize ?? 1,
    contrast: s.contrast ?? false,
    large_cursor: !!s['big-cursor'],
    reading_guide: !!s['readable-guide'],
    screen_reader: !!s['screen-reader'],
    dyslexia_font: !!s['readable-font'],
  }
}

export default function toggleMenu() {
  const dialog = document.getElementById('asw-menu-dialog') as HTMLDialogElement | null
  if (!dialog) return

  const isOpen = !dialog.open
  if (isOpen) {
    dialog.showModal()
    emitTrack('CLICK_ACCESSIBILITY_WIDGET', buildSettings())
  } else {
    dialog.close()
    emitTrack('CLOSE_ACCESSIBILITY_WIDGET', buildSettings())
  }

  const trigger = document.querySelector('.asw-menu-btn')
  if (trigger) {
    trigger.setAttribute('aria-expanded', String(isOpen))
  }
}
